// src/utils/index.ts
var interpolationTheme = (expressions, theme) => {
  if (Array.isArray(expressions)) {
    return expressions.map(
      (expression) => interpolationTheme(expression, theme)
    );
  }
  if (typeof expressions === "function") {
    return expressions(theme);
  }
  return expressions;
};

export { interpolationTheme };
